<template>
  <div class="main_container">

  <section class="main_sec">
    <swiper :pagination="{ clickable: true }" :speed="500" :loop="true" :effect="'fade'" :modules="modules">
        <!-- slide1 -->
        <swiper-slide class="d-flex swiper-slide">
          <picture>
            <source 
              srcset="@/assets/img/slides/main_slideImgL_230705.jpg"
              media="(min-width: 1024px)"
            />
            <source 
              srcset="@/assets/img/slides/main_slideImgS_230705.jpg"
              media="(min-width: 600px)"
            />
            <img src="@/assets/img/slides/main_slideImgS_230705.jpg" />
          </picture>
        </swiper-slide>
      
        <!-- slide2 -->
        <swiper-slide class="d-flex swiper-slide">
          <picture>
            <source 
              srcset="@/assets/img/slides/main_slideImgL_230705-2.jpg"
              media="(min-width: 1024px)"
            />
            <source 
              srcset="@/assets/img/slides/main_slideImgS_230705-2.jpg"
              media="(min-width: 600px)"
            />
            <img src="@/assets/img/slides/main_slideImgS_230705-2.jpg" />
          </picture>
        </swiper-slide>


    </swiper>

    <button class="ctalk_btn">
      <img src="@/assets/img/user/ctalk_btn.svg">
    </button>
  </section>


  <section class="bg-blk main_sec2">
    <svg class="main_section2_obj" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" width="52.8" height="126" viewBox="0 0 52.8 126"><path d="M7.2,0C18.4,15,18.7,17.3,20.8,24.4A45,45,0,0,1,23,39.1c0,9.4-1.2,18.8-8.3,31C12.9,73.2,9,78.1,6,82.6L4.9,84.3a26.5,26.5,0,0,0-3,5.5l-.2.5h0A26,26,0,0,0,0,99.6a26.4,26.4,0,1,0,52.8,0,4.1,4.1,0,0,0-.1-1.1h.1s0-.5-.1-1.4v-.4a8.8,8.8,0,0,0-.3-2.1,2.9,2.9,0,0,0-.2-.9,34.7,34.7,0,0,0-3.2-8.9c-2.6-5.1-8.7-11.6-11-15.3-5.7-9.3-8-21-8-30.4s5.3-22,8.1-27.3,4.3-7.3,6.2-10.3L45.3,0H7.2" transform="translate(0 0)" style="fill:#fff"/></svg>
    
    <div class="mag-auto sec_txt_wr">
      <p class="font-mont fw-bolder subtitle mag-bt-2 color-y2">
        DIGITAL WORKPLACE
      </p>
      <p class="font-gmar fw-bolder title mag-bt-2 color-mlg">
        지금 우리 회사는 . .
      </p>
    </div>
    
    <div class="marquee_wr">
      <div class="marquee font-noto">
        <div class="marquee__inner">
          <span>자동화시스템 좋은데 우리 같은 소규모 회사도 사용가능할까?</span>
          <span>협업툴로는 2% 부족해</span>
          <span>회의가 언제지?  회의자료는?  미팅룸 사용신청은?</span>
          <span>자동화시스템 좋은데 우리 같은 소규모 회사도 사용가능할까?</span>
          <span>협업툴로는 2% 부족해</span>
          <span>회의가 언제지?  회의자료는?  미팅룸 사용신청은?</span>
        </div>
      </div>
      <div class="marquee marquee2 font-noto">
        <div class="marquee__inner">
          <span>무거운 짐들고 문열기는 늘 짜증나</span>
          <span>아.. 이런건 누가 좀 대신 해줘</span>
          <span>도대체 직원들이 필요한게 뭐야?!</span>
          <span>이런건 제때제때 알려줘, 제발</span>
          <span>무거운 짐들고 문열기는 늘 짜증나</span>
          <span>아.. 이런건 누가 좀 대신 해줘</span>
          <span>도대체 직원들이 필요한게 뭐야?!</span>
          <span>이런건 제때제때 알려줘, 제발</span>
          <span>무거운 짐들고 문열기는 늘 짜증나</span>
        </div>
      </div>
      <div class="marquee marquee3 d-flex font-noto">
        <span class="bg-yellow2 color-b font-gmar fw-bolder">WHY?</span>
        <div class="marquee__inner">
          <span>대다수의 자동화 시스템은 근로자가 위치하는 공간을 고려하지 않고, 근로자의 행동만을 기반으로 개발</span>
          <span>대다수의 자동화 시스템은 근로자가 위치하는 공간을 고려하지 않고, 근로자의 행동만을 기반으로 개발</span>
          <span>대다수의 자동화 시스템은 근로자가 위치하는 공간을 고려하지 않고, 근로자의 행동만을 기반으로 개발</span>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="pos-rel h-100p">
      <div class="mag-auto sec_txt_wr">
        <p class="font-mont fw-bolder subtitle">
          DIGITAL WORKPLACE
        </p>
        <p class="font-gmar title2">
          버라이어티하고 위대한 일들이 시작되는<br>
          우리들의 워크플레이스에<br>
          공간반응 시스템이 들어갑니다<br>
          <b>새로운 경험</b>이 시작됩니다
        </p>

        <a href="" class="main_section3_link font-mont fw-bolder d">
          <h3 class="d-flex flex-sb">VIEW<i class="xi-long-arrow-right"></i></h3>
        </a>
      </div>
      
      <div class="main_svg_wr">
        <img src="@/assets/img/user/user_office_bcs.svg">
        <!-- <img src=""> interactive for office.svg -->
      </div>
    </div>
  </section>
  </div>
</template>

<script>

import SwiperClass, { EffectFade, Pagination  } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

// import swiper module styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
// more module style...

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  setup() {
    return {
      modules: [Pagination, EffectFade]
    }
  },
  data () {
    return {
    }
  },
  created () {
   // this.getData()
  },
  methods: {
  },
  mounted() {
  }
}
</script>